import request, { METHODS } from "src/utils/api-base";

const inventoryTransactionApis = {
  list: (params?: any) =>
    request({
      route: "/app/inventory-transaction/list",
      method: METHODS.GET,
      params,
      auth: true,
    }),

  get: (id: string) =>
    request({
      route: `/app/inventory-transaction/${id}`,
      method: METHODS.GET,
      auth: true,
    }),
};

export default inventoryTransactionApis;
